import { createSlice } from "@reduxjs/toolkit";

const { reducer, actions } = createSlice({
    name: "session",
    initialState: {
        server: null,
        user: null,
        user_loaded: false,
    },
    reducers: {
        updateServer(state, action) {
            state.server = action.payload;
        },
        updateUser(state, action) {
            state.user = action.payload;
            state.user_loaded = true;
        },
    },
});

export { actions as sessionActions };
export { reducer as sessionReducer };
